import React from "react";
const Pylecture2 = () => {
  return (
    <div className="bg-gray-100 flex items-center justify-center min-h-screen">
      <div className="w-full max-w-xl p-4 bg-white rounded-lg shadow-md">
        <div className="aspect-w-16 aspect-h-9 mb-4">
          <iframe
            className="w-full rounded-lg"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/q-u3S-Xusuo?si=STu33OSrgT6Jzde6"
            title="Python"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen;"
            //referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <h2 className="text-2xl font-bold mb-2">
          📚 Python Programming - Lecture 2: Getting Started with Python IDEs,
          Variables, and Naming Conventions 🎉
        </h2>
        <p className="text-gray-700">
          Welcome back to our Python Programming series! In this second lecture,
          we dive deeper into the foundational aspects of Python. Whether you're
          a beginner or looking to refresh your basics, this video will cover:
          <br />
          <br />
          🔹 Introduction to Python IDEs: Discover the best Integrated
          Development Environments (IDEs) for Python, their features, and how to
          set them up for efficient coding.
          <br />
          <br />
          🔹 Python Variables: Learn what variables are, how to use them, and
          why they are essential in programming.
          <br />
          <br />
          🔹 Variable Naming Conventions: Understand the best practices for
          naming your variables to make your code readable and maintainable.
          <br />
          <br />
          🔹 Examples of Valid and Invalid Variable Types: Get hands-on examples
          and explanations of which variable names are acceptable in Python and
          which ones will cause errors.
          <br />
          <br />
          Join us to build a solid foundation in Python programming and enhance
          your coding skills. Don't forget to like, share, and subscribe for
          more tutorials!
          <br />
          <br />
          Happy coding! 💻
        </p>
      </div>
    </div>
  );
};

export default Pylecture2;
